/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ISimpleFunctionRegistryFeature,
  ISimpleFunctionRegistryFeatureInterface,
} from "../ISimpleFunctionRegistryFeature";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
      {
        internalType: "address",
        name: "impl",
        type: "address",
      },
    ],
    name: "extend",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class ISimpleFunctionRegistryFeature__factory {
  static readonly abi = _abi;
  static createInterface(): ISimpleFunctionRegistryFeatureInterface {
    return new utils.Interface(_abi) as ISimpleFunctionRegistryFeatureInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ISimpleFunctionRegistryFeature {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ISimpleFunctionRegistryFeature;
  }
}
